var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 42,
    viewBox: "0 0 276 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3669_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.0098 10.1814V0H116.753V10.1814H103.468V41.9235H92.2953V10.1814H79.0098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.047 41.9235V0H152.657V10.1814H131.219V16.4699H148.43V25.4534H131.219V31.742H152.657V41.9235H120.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.76 41.9235V0H171.348L186.143 26.352H186.747L185.841 20.9617V0H197.013V41.9235H183.425L168.63 15.5716H168.026L168.932 20.9617V41.9235H157.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.675 41.9235V0H236.284V10.1814H214.847V16.4699H232.058V25.4534H214.847V31.742H236.284V41.9235H203.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.067 10.1814V0H275.81V10.1814H262.524V41.9235H251.351V10.1814H238.067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2954 3.77113C48.8069 1.42866 46.1418 0.0257353 43.165 0.0257353H26.7496C26.5368 0.0128645 26.3243 0 26.1115 0C25.899 0 25.6864 0.0128645 25.4737 0.0257353H9.05824C6.08134 0.0257353 3.41631 1.42866 1.92786 3.77113C0.439411 6.11361 0.439411 8.90659 1.92786 11.2491L18.9812 38.059C20.4697 40.4014 23.1347 41.8042 26.1115 41.8042C29.0885 41.8042 31.7534 40.4014 33.2419 38.059L50.2954 11.2491C51.7839 8.91945 51.7839 6.11361 50.2954 3.77113ZM29.3011 35.9996C28.635 37.0421 27.4441 37.6728 26.1115 37.6728C24.7792 37.6728 23.5884 37.0421 22.9221 35.9996L13.3251 20.915L22.9221 5.81758C23.5175 4.87802 24.524 4.28596 25.6864 4.17013H26.5368C27.6993 4.28596 28.7058 4.8909 29.3011 5.81758L38.8981 20.9022L29.3011 35.9996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3669_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 42,
    fill: "white",
    transform: "translate(0.811523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo8);
export default __webpack_public_path__ + "static/media/logo8.72d0784d2f8e3f0b0da7a688e856c533.svg";
export { ForwardRef as ReactComponent };